module.exports = __webpack_public_path__ + "static/media/denied.ca15d0d9.mp3";